'use strict';

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */

import util from '../../util';
import modal from '../../modal';

const NICKNAME_REGEX = /[^a-zA-Z\s.-]/g;

function initializeEvents() {
    if($('.user-info-section').length){
        var maxHeight_profileContainer = Math.max.apply(null, $('.user-info-section .profile-container').map(function(){return $(this).height()}));

        if (window.innerWidth <= 480) {
            $('.user-info-section .profile-container').height(maxHeight_profileContainer).find('.profile-container-inner').addClass('mobile-align-center');
        }

        window.addEventListener('resize', function(event){
            if (!(window.innerWidth <= 480)) {
                $('.user-info-section .profile-container').height('auto').find('.profile-container-inner').removeClass('mobile-align-center');
            } else {
                $('.user-info-section .profile-container').height(maxHeight_profileContainer).find('.profile-container-inner').addClass('mobile-align-center');
            }
        });
    }
    $('.small .edit').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.section').toggleClass('open');
        if($(this).closest('.section').hasClass('open')){
            $(this).text('Close');
            $(this).closest('.section').find('.success-msg').hide();
            $(this).closest('.section').find('.form-submit').show();
        } else {
            $(this).text('Edit');
        }
    });

    $('.small .arrow').on('click', function (e) {
        e.preventDefault();

        var arrowImgElement = $(this).find('.arrow-image');
        var currentImg = arrowImgElement.attr('src');
        var nextImg = arrowImgElement.data('secondimage');

        arrowImgElement.attr('src', nextImg);
        arrowImgElement.data('secondimage', currentImg);

        $(this).closest('.section').toggleClass('open');
    });

    // $('.account-details-section .input-select').on('change', autoFormSubmitter);
    $('.account-details-section .input-text')
        // .on('change', autoFormSubmitter)
        .on('keyup', function () {
            const nicknameInput = $(this);
            const newValue = nicknameInput.val().replace(NICKNAME_REGEX, '');
            nicknameInput.val(newValue);
        });

    $('.profile-completion-form').on('submit', function(e) {
        e.preventDefault();
        if ($(e.target).closest('.birthday-form').length) {
            if ($('.input-select.birthmonth').val() == '') {
              $('.birthdata-message').text('Please enter a valid birth month').trigger('focus');
              return false;
            } else {
              $('.birthdata-message').text('');
            }
      
            if ($('.input-select.dob').val() == '') {
              $('.birthdata-message').text('Please enter a valid birth date').trigger('focus');
              return false;
            } else {
              $('.birthdata-message').text('');
            }
          }
        formSubmitRequest($(this));
    });

    initializeCustomSelects();
    initializeLoginCarousel();
}

// function autoFormSubmitter() {
//     if ($(this).val() === '') {
//         return;
//     }

//     var form = $(this).closest('form');

//     if (form.hasClass('unified-submit')) {
//         var formFields = form.find('input, select');

//         for (var i = 0; i < formFields.length; i++) {
//             var field = formFields[i];

//             if ($(field).val() === '') {
//                 return;
//             }
//         }
//     }

//     form.trigger('submit');
// }

function formSubmitRequest(form) {
    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };

    $.ajax(options).done(function (response) {
        if (!response.success) {
            console.log(response.message);
        } else {
            var completionPercentage = response.profileCompletionPercentage;

            $('.profile-completion').text(completionPercentage);

            if (response.birthdayDate) {
                var birthdayMessage = Resources.YOUR_BIRTHDAY + ' ' + response.birthdayDate;
                $('.birthday-top-section').text(birthdayMessage);
            }

            if (form.hasClass('nickname-form')) {
                const hideDelay = 5000;
                const animationDuration = 400;
                const nicknameWrapper = $('.user-nickname');
                nicknameWrapper.find('.success-icon').fadeIn(animationDuration).delay(hideDelay).fadeOut(animationDuration);
                nicknameWrapper.find('.nickname').text(response.nickname);
                nicknameWrapper.find('.greeting').text(response.greeting);
                nicknameWrapper.find('.nickname-description').html(response.nicknameDescription);
                form.find('input.nickname').val(response.nickname);
            }
            const successMsgText = form.hasClass('nickname-form') ? 'Your nickname has been updated.' : form.hasClass('birthday-form') ? 'Your birthday has been updated.' : 'Your profile has been updated';
            form.find('.form-submit').hide();
            form.find('.success-msg').text(successMsgText).show();
        }
    });
}

function initializeLoginCarousel() {
    var loginCarouselContainer = $('.beautystation-login-carousel-container');
    if (loginCarouselContainer.length) {
        $('body').addClass('disable-newsletter-modal');

        var beautyStationLoginModal = modal.create('#beautystation-login-modal-cntr', '.modal-body', {});
        beautyStationLoginModal.addCustomClass('beautystation-login-modal');
        beautyStationLoginModal.events.onOpen(function () {
            // Slick needs its container visible to be properly initialized. However onOpen fires before the modal is visible. 
            // Foundation.Reveal plugin works like this because of the animations that can be applied to the modal.
            // To mitigate this issue with Slick and Foundation.Reveal, we have to bind transitionend event on the modal 
            // container and only then to initialize the slick carousel. This should be executed only once to not
            // init the carousel again when carousel animation happens
            beautyStationLoginModal.$cntr.one(Foundation.transitionend(), function() {
                loginCarouselContainer.slick({
                    arrows: true,
                    autoplay: false,
                    infinite: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 480,
                        settings: {
                            arrows: false
                        }
                    }]
                });
            });
        });
        beautyStationLoginModal.open();

        $('#beautystation-login-modal-cntr').on('click', '.close-button, .beautystation-link', function () {
            hideOnboardingScreen();
        });

        beautyStationLoginModal.events.onClose(function () {
            $('body').removeClass('disable-newsletter-modal');
            $('body').trigger('showNewsletterModal');
        })
    }
}

function initializeCustomSelects() {
    $('.custom-select .input-select').each(function () {

        // Cache the number of options
        var $this = $(this),
            numberOfOptions = $(this).children('option').length;

        // Hides the select element
        $this.addClass('hide');

        // Wrap the select element in a div
        $this.wrap('<div class="select"></div>');

        // Cache the styled div
        var selectedOption = $this.children('option[selected]').length > 0 ? $this.children('option[selected]').text() : $this.children('option').eq(0).text();

        // Insert a styled div to sit over the top of the hidden select element and show the selected option in the styled div
        $this.after('<div class="styledSelect">' + selectedOption + '<div class="arrow-icon"></div></div>');
        var $styledSelect = $this.next('div.styledSelect');

        // Insert an unordered list after the styled div and also cache the list
        var $list = $('<ul />', {
            'class': 'options',
            'style': 'display:none'
        }).insertAfter($styledSelect);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            var customFirstOption = $this.attr('custom-first-option');

            if (customFirstOption && i === 0) {
                $('<li />', {
                    text: customFirstOption,
                    class: 'unselectable'
                }).appendTo($list);
            } else {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

        }

        // Cache the list items
        var $listItems = $list.children('li:not(.unselectable)');

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active').next('ul.options').hide();
            });
            $(this).toggleClass('active').next('ul.options').toggle();
        });

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option and triggers change to fire form submit
        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.html($(this).text() + '<div class="arrow-icon"></div>').removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            $this.trigger('change');
        });

        // Hides the unordered list when clicking outside of it
        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

    });
}

function hideOnboardingScreen() {
    var url = $('[name="hideOnboardingScreenUrl"]').val();

    var options = {
        url: util.ajaxUrl(url),
        method: 'POST',
        cache: false
    };

    $.ajax(options).done(function (response) {
        if (!response.success) {
            console.log(response.message);
        }
    });
}

var beautyStationLanding = {
    init: function () {
        initializeEvents();
    }
};

export default beautyStationLanding;
